<template>
    <el-form>
        <el-form-item label='谨慎开关：'>
            <el-switch v-model="isDetail" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <el-form-item>
            <div>{{$t("reward_editor.19")}}：</div>
            <el-switch v-model="countSwitch" :active-text='$t("reward_editor.20")' :inactive-text='$t("reward_editor.21")'>
            </el-switch>

            <div>
                <div>{{$t("reward_editor.22")}}：</div>
                <template v-if="isDetail == false">
                    <el-input-number v-model.number="count1" :min="1" :max="100000000" />
                    <span>快捷选项：</span>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 100) : (count1 = count1 + 100)">一百</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 1000) : (count1 = count1 + 1000)">一千</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 10000) : (count1 = count1 + 10000)">一万</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 100000) : (count1 = count1 + 100000)">十万</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 1000000) : (count1 = count1 + 1000000)">百万</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 10000000) : (count1 = count1 + 10000000)">千万</el-button>
                </template>

                <template v-if="isDetail == true">
                    <el-input-number v-model="num.h" :min="0" :max="10"  placeholder='请输入千万位'></el-input-number>
                    <span>千万</span>
                    <el-input-number v-model="num.g" :min="0" :max="9" placeholder='请输入百万位'></el-input-number>
                    <span>百万</span>
                    <el-input-number v-model="num.f" :min="0" :max="9" placeholder='请输入十万位'></el-input-number>
                    <span>十万</span>
                    <el-input-number v-model="num.e" :min="0" :max="9" placeholder='请输入万位'></el-input-number>
                    <span>万</span>
                    <el-input-number v-model="num.d" :min="0" :max="9" placeholder='请输入千位'></el-input-number>
                    <span>千</span>
                    <el-input-number v-model="num.c" :min="0" :max="9" placeholder='请输入百位'></el-input-number>
                    <span>百</span>
                    <el-input-number v-model="num.b" :min="0" :max="9" placeholder='请输入十位'></el-input-number>
                    <span>十</span>
                    <el-input-number v-model="num.a" :min="0" :max="9" placeholder='请输入个位'></el-input-number>
                    <span>个</span>
                </template>
            </div>

            <div v-if="countSwitch">
                <div>{{$t("reward_editor.23")}}：</div>
                <template v-if="isDetail == false">
                    <el-input-number v-model.number="count2" :min="1" :max="100000000" />
                    <span>快捷选项：</span>
                    <el-button size="mini" @click="count2 = count2 + 10000">一万</el-button>
                    <el-button size="mini" @click="count2 = count2 + 100000">十万</el-button>
                    <el-button size="mini" @click="count2 = count2 + 1000000">百万</el-button>
                    <el-button size="mini" @click="count2 = count2 + 10000000">千万</el-button>
                </template>

                <template v-if="isDetail == true">
                    <el-input-number v-model="num2.h" :min="0" :max="10"  placeholder='请输入千万位'></el-input-number>
                    <span>千万</span>
                    <el-input-number v-model="num2.g" :min="0" :max="9" placeholder='请输入百万位'></el-input-number>
                    <span>百万</span>
                    <el-input-number v-model="num2.f" :min="0" :max="9" placeholder='请输入十万位'></el-input-number>
                    <span>十万</span>
                    <el-input-number v-model="num2.e" :min="0" :max="9" placeholder='请输入万位'></el-input-number>
                    <span>万</span>
                    <el-input-number v-model="num2.d" :min="0" :max="9" placeholder='请输入千位'></el-input-number>
                    <span>千</span>
                    <el-input-number v-model="num2.c" :min="0" :max="9" placeholder='请输入百位'></el-input-number>
                    <span>百</span>
                    <el-input-number v-model="num2.b" :min="0" :max="9" placeholder='请输入十位'></el-input-number>
                    <span>十</span>
                    <el-input-number v-model="num2.a" :min="0" :max="9" placeholder='请输入个位'></el-input-number>
                    <span>个</span>
                </template>
            </div>
        </el-form-item>
        <el-form-item label='生成数量1预览:'>
            <template v-if="isDetail == true">
                {{num.a*1 + num.b*10 + num.c*100  + num.d*1000 + num.e*10000 + num.f*100000 + num.g*1000000 + num.h*10000000 }}
                （
                <template v-if="num.h >= 0">{{num.h }}千万</template>
                <template v-if="num.g >= 0">{{num.g }}百万</template>
                <template v-if="num.f >= 0">{{num.f }}十万</template>
                <template v-if="num.e >= 0">{{num.e }}万 </template>
                <template v-if="num.d >= 0">{{num.d }}千 </template>
                <template v-if="num.c >= 0">{{num.c }}百 </template>
                <template v-if="num.b >= 0">{{num.b }}十 </template>
                <template v-if="num.a >= 0">{{num.a }}个 </template>
                ）
            </template>
            <template v-if="isDetail == false">
                {{count1}}
                （
                <template v-if="count1 >= 10000000"> {{parseInt((count1 % 100000000) / 10000000) }}千万 </template>
                <template v-if="count1 >= 1000000"> {{parseInt((count1 % 10000000) / 1000000) }}百万 </template>
                <template v-if="count1 >= 100000"> {{parseInt((count1 % 1000000) / 100000) }}十万 </template>
                <template v-if="count1 >= 10000"> {{parseInt((count1 % 100000) / 10000) }}万 </template>
                <template v-if="count1 >= 1000"> {{parseInt((count1 % 10000) / 1000) }}千 </template>
                <template v-if="count1 >= 100"> {{parseInt((count1 % 1000) / 100) }}百 </template>
                <template v-if="count1 >= 10"> {{parseInt((count1 % 100) / 10) }}十 </template>
                {{parseInt(count1 % 10) }}个
                ）
            </template>
        </el-form-item>
        <el-form-item label='生成数量2预览:' v-if="countSwitch">
            <template v-if="isDetail == true">
                {{num2.a*1 + num2.b*10 + num2.c*100  + num2.d*1000 + num2.e*10000 + num2.f*100000 + num2.g*1000000 + num2.h*10000000 }}
                （
                <template v-if="num2.h >= 0">{{num2.h }}千万</template>
                <template v-if="num2.g >= 0">{{num2.g }}百万</template>
                <template v-if="num2.f >= 0">{{num2.f }}十万</template>
                <template v-if="num2.e >= 0">{{num2.e }}万 </template>
                <template v-if="num2.d >= 0">{{num2.d }}千 </template>
                <template v-if="num2.c >= 0">{{num2.c }}百 </template>
                <template v-if="num2.b >= 0">{{num2.b }}十 </template>
                <template v-if="num2.a >= 0">{{num2.a }}个 </template>
                ）
            </template>
            <template v-if="isDetail == false">
                {{count2}}
                （
                <template v-if="count2 >= 10000000"> {{parseInt((count2 % 100000000) / 10000000) }}千万 </template>
                <template v-if="count2 >= 1000000"> {{parseInt((count2 % 10000000) / 1000000) }}百万 </template>
                <template v-if="count2 >= 100000"> {{parseInt((count2 % 1000000) / 100000) }}十万 </template>
                <template v-if="count2 >= 10000"> {{parseInt((count2 % 100000) / 10000) }}万 </template>
                <template v-if="count2 >= 1000"> {{parseInt((count2 % 10000) / 1000) }}千 </template>
                <template v-if="count2 >= 100"> {{parseInt((count2 % 1000) / 100) }}百 </template>
                <template v-if="count2 >= 10"> {{parseInt((count2 % 100) / 10) }}十 </template>
                {{parseInt(count2 % 10) }}个
                ）
            </template>
        </el-form-item>

        <el-form-item>
            <div>{{$t("reward_editor.24")}}：</div>
            <el-switch v-model="rateSwitch" :active-text='$t("reward_editor.25")' :inactive-text='$t("reward_editor.26")'>
            </el-switch>
            <div v-if="rateSwitch">{{$t("reward_editor.27")}}：</div>
            <el-input-number v-if="rateSwitch" v-model.number="rate" :step="0.1" :max="0.999999999" />
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        name: "component_reward_count",
        data() {
            return {
                isDetail: false,
                num: {
                    a: 0,
                    b: 0,
                    c: 0,
                    d: 0,
                    e: 0,
                    f: 0,
                    g: 0,
                    h: 0,
                },
                num2: {
                    a: 0,
                    b: 0,
                    c: 0,
                    d: 0,
                    e: 0,
                    f: 0,
                    g: 0,
                    h: 0,
                },
                count1: 1,
                count2: 1,
                countSwitch: false,
                rateSwitch: false,
                rate: 0.1,

                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],
            }
        },
        props: ['confirmFinal', 'currentReward'],
        watch:{
            confirmFinal() {
                if (this.confirmFinal) {
                    this.deliverCountValue();
                }
            },

            currentReward(n, l) {
                if (n!==l) {
                    this.resolveRewardStr(this.currentReward);
                }
            },
        },
        methods: {
            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if(fateArray.length>1){
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                            self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            deliverCountValue() {
                let self = this;
                //数量串
                let finalCount = '';

                if (self.isDetail) {
                    if (self.countSwitch) {
                        finalCount = (self.num.a * 1 + self.num.b * 10 + self.num.c * 100 + self.num.d * 1000 + self.num
                            .e * 10000 + self.num.f * 100000 + self.num.g * 1000000 + self.num.h * 10000000) + "-" + (self.num2.a * 1 + self.num2.b * 10 + self.num2.c * 100 + self.num2.d * 1000 + self.num2
                            .e * 10000 + self.num2.f * 100000 + self.num2.g * 1000000 + self.num2.h * 10000000);
                    } else {
                        finalCount = self.num.a * 1 + self.num.b * 10 + self.num.c * 100 + self.num.d * 1000 + self.num
                            .e * 10000 + self.num.f * 100000 + self.num.g * 1000000 + self.num.h * 10000000;
                    }
                } else {
                    if (self.countSwitch) {
                        finalCount = self.count1 + "-" + self.count2;
                    } else {
                        finalCount = self.count1
                    }
                }

                var count1 = '';
                var count2 = '';
                if (self.countSwitch) {
                    count1 = finalCount.split('-')[0];
                    count2 = finalCount.split('-')[1];
                } else {
                    count1 = finalCount;
                    count2 = '';
                }

                // this.$emit('countValue', count1, count2, self.rateSwitch, self.rate, self.isDetail, self.countSwitch);
                this.$emit('countValue', finalCount, self.rateSwitch, self.rate);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/component_reward_count.vue